import { uploadImage } from "@/services/upload";
import { Box, Card, CardMedia } from "@mui/material";
import { useEffect } from "react";

export default function NewImageContainer({ file, meta, setMeta }) {
  const handleFileChange = async () => {
    const url = await uploadImage(file);
    setMeta((prev) => ({ ...prev, url }));
  };

  useEffect(() => {
    if (file) {
      handleFileChange();
    }
  }, [file]);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: 4,
          mt: 2,
        }}
      >
        <Card style={{ borderRadius: "20px" }}>
          <CardMedia
            component="img"
            src={file ? URL.createObjectURL(file) : ""}
            style={{ borderRadius: "10px" }}
          />
        </Card>
      </Box>
    </Box>
  );
}
